export default __webpack_public_path__ + "static/Which-April2021-3ad472b5a390839e6f170471b62c210a.png";